import firebase from 'firebase/app';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBvEGbxz_nyCmebcQv3-Z162ev-qGHdfRY",
  authDomain: "independent-real-estate-broker.firebaseapp.com",
  databaseURL: "https://independent-real-estate-broker.firebaseio.com",
  projectId: "independent-real-estate-broker",
  storageBucket: "independent-real-estate-broker.appspot.com",
  messagingSenderId: "207165405311",
  appId: "1:207165405311:web:d50eb820bbdd4ea1af274a",
  measurementId: "G-KC553XN5FJ"
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export {
  storage, firebase as default
}
